var map = {
	"./Chinese.ts": [
		7,
		7,
		330
	],
	"./Emote.ts": [
		427,
		9,
		858
	],
	"./English.ts": [
		468,
		9,
		184
	],
	"./Japanese.ts": [
		855,
		9,
		410
	],
	"./Korean.ts": [
		55,
		9,
		227
	],
	"./Ngrams.ts": [
		805,
		9,
		273
	],
	"./Numpad.ts": [
		283,
		9,
		683
	],
	"./Shell.ts": [
		433,
		9,
		159
	],
	"./defs/Chinese.ts": [
		944,
		7,
		704
	],
	"./defs/English100.ts": [
		104,
		9,
		885
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59;
module.exports = webpackAsyncContext;